import { HotspotsMapComponent } from './hotspots-map/hotspots-map.component';
import { HotspotsAlertsComponent } from './hotspots-alerts/hotspots-alerts.component';
import { Routes } from '@angular/router';
import { HotspotTrackingComponent } from './hotspot-tracking.component';
import { ManageHotspotsGuard } from '../core/guards/manage-hotspots.guard';
import { HotspotListComponent } from './hotspot-list/hotspot-list.component';
import {AuthGuard} from '@auth0/auth0-angular';;


export const HOTSPOT_TRACKING_ROUTES: Routes = [
  {
    path: 'hotspots',
    data: { hotspotTrackingView: true },
    component: HotspotTrackingComponent,
    canActivate: [AuthGuard, ManageHotspotsGuard],
    children: [
      { path: 'list', component: HotspotListComponent },
      { path: 'map', component: HotspotsMapComponent },
      { path: 'map/:id', component: HotspotsMapComponent },
      { path: 'alerts', component: HotspotsAlertsComponent },
      { path: '**', redirectTo: 'list' }
    ]
  }
];
